import { SEARCH_PAGE, TICKETS_PAGE } from 'constants/pages'
import { selectCurrentFolderItem } from 'ducks/folders/selectors/items'
import { createSelector } from 'reselect'
import { selectCurrentAction } from 'selectors/location'
import { emptyObj } from 'util/objects'

export const selectFolderRouteAction = createSelector(
  selectCurrentAction,
  selectCurrentFolderItem,
  (action, folderItem) => {
    const hasQueryContext =
      action?.meta?.query && Object.keys(action.meta.query).length > 0
    return {
      ...action,
      type:
        hasQueryContext || folderItem !== emptyObj ? TICKETS_PAGE : SEARCH_PAGE,
      payload: {},
    }
  }
)
